/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_pomodoro_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Running a single 25-minute focus block on one task with no notifications or tab-switching.`)
};

const es_timer_pomodoro_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Realizar un único bloque de enfoque de 25 minutos en una tarea, sin notificaciones ni cambios de pestaña.`)
};

const de_timer_pomodoro_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einen einzelnen 25-minütigen Fokus-Block an einer Aufgabe absolvieren, ohne Benachrichtigungen oder Tab-Wechsel.`)
};

const nl_timer_pomodoro_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eén 25-minuten focusblok draaien op één taak, zonder meldingen of tabbladwissels.`)
};

const fr_timer_pomodoro_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réaliser un seul bloc de concentration de 25 minutes sur une tâche, sans notifications ni changement d’onglet.`)
};

const it_timer_pomodoro_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dedicare un unico blocco di 25 minuti a un solo compito, senza notifiche né cambi di scheda.`)
};

const pt_br2_timer_pomodoro_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazer um único bloco de foco de 25 minutos em uma tarefa, sem notificações nem troca de abas.`)
};

const pt_timer_pomodoro_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazer um único bloco de foco de 25 minutos numa tarefa, sem notificações nem mudanças de separador.`)
};

const ja_timer_pomodoro_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知やタブ切り替えなしで、1つのタスクに25分間集中するセッションを行う。`)
};

const zh_timer_pomodoro_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在没有通知和切换标签页的情况下，专注完成一项任务的单个25分钟专注时段。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_pomodoro_use1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_pomodoro_use1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_pomodoro_use1", locale)
	if (locale === "en") return en_timer_pomodoro_use1(inputs)
	if (locale === "es") return es_timer_pomodoro_use1(inputs)
	if (locale === "de") return de_timer_pomodoro_use1(inputs)
	if (locale === "nl") return nl_timer_pomodoro_use1(inputs)
	if (locale === "fr") return fr_timer_pomodoro_use1(inputs)
	if (locale === "it") return it_timer_pomodoro_use1(inputs)
	if (locale === "pt-BR") return pt_br2_timer_pomodoro_use1(inputs)
	if (locale === "pt") return pt_timer_pomodoro_use1(inputs)
	if (locale === "ja") return ja_timer_pomodoro_use1(inputs)
	return zh_timer_pomodoro_use1(inputs)
};